import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import chartPreview from './plCapsulePreview.png';

export const plCapsuleDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Profit / Loss Capsule gives high-level overview of the
                Profit/Loss against the chosen benchmark. Requires a position
                from selected orders.
            </div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            title: 'Chart',
            src: chartPreview,
            altText: 'pl-capsule-chart-preview',
        },
    ],
};
